import React, { useState, useEffect, memo, useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useTheme } from '@material-ui/core/styles'
import {
  SwapHoriz as Splash1Icon,
  ErrorRounded as Splash2Icon,
} from '@material-ui/icons'

import { setActiveConversation } from '../../../redux/activeConversation/actions'
import {
  setUndockActiveConversation,
  setUndockConversation,
  setUndockConversations,
} from '../../../redux/undock/actions'
import Tooltip from '../../atoms/display/tooltip'
import Typography from '../../../components/atoms/display/typography'
import Avatar from '../avatar/customer'
import Status from './Status'

import useStyles from './itemStyle'

const Item = (props) => {
  const size = useSelector((state) => state.preferences)

  const { t } = useTranslation()
  const dispatch = useDispatch()
  const theme = useTheme()
  const classes = useStyles()
  const activeConversation = useSelector((state) => state.activeConversation)
  const conversations = useSelector(
    (state) => state.conversations.conversations
  )
  const conversation = conversations[props?.data?.conversationId]
  const messages = useSelector((state) => state.conversations.messages)
  const user = useSelector((state) => state.user)
  const [unreadMsgs, setUnreadMsgs] = useState(0)
  const features = useSelector((state) => state.features)
  const objFeatureTab = useMemo(() => {
    return features?.find((e) => e.name === 'Tab')
  }, [features])

  const lastMessageConversation = useMemo(()=>{
    try {
      const msg = messages[props?.chatId] ?? [];
      const messagesOrdered = msg.filter(msg => msg.by !== 'ai').sort((a,b)=> new Date(a.sentTime) - new Date(b.sentTime))
      const lengthOfMessages = messagesOrdered.length;

      const lastMsg = messagesOrdered[lengthOfMessages - 1];
      return lastMsg ?? conversation.lastMessage;
    } catch (error) {
      return '';
    }    
  },[messages, props, conversation]);

  useEffect(() => {
    let msgs = messages[props?.chatId] ?? []
    let unread = msgs
      ?.filter((msg) => msg.unread)
      ?.reduce((acc, cur) => acc + 1, 0)

    setUnreadMsgs(unread)
  }, [props?.chatId, props?.data])

  const hasTransferHistory = useCallback(() => {
    return props?.data?.users?.some(
      (el) => el?.transferred_time && el?.user_id !== user?.id
    )
  }, [props?.data, user])

  const hasAlertBadge = useCallback(() => {}, [props?.data])

  const renderSplash = () => {
    if (hasTransferHistory()) {
      const badgeTitle = () => {
        return (
          <>
            <div
              style={{
                display: 'flex',
                fontWeight: theme.typography.fontWeightBold,
                alignItems: 'center',
              }}
            >
              <Splash1Icon
                style={{
                  fontSize: 16,
                  marginRight: 8,
                }}
              />
              <div>{t('tooltip.transferBadge')}</div>
            </div>
          </>
        )
      }
      return (
        <>
          <div className={classes.rootSplash1}>
            <Tooltip title={badgeTitle()} placement="right">
              <Splash1Icon
                style={{
                  fontSize: 14,
                  color: '#fff',
                  marginBottom: -40,
                  transform: 'rotate(-45deg)',
                }}
              />
            </Tooltip>{' '}
          </div>
        </>
      )
    } else if (hasAlertBadge()) {
      return (
        <>
          <div className={classes.rootSplash2}>
            <Splash2Icon
              style={{
                fontSize: 14,
                color: '#fff',
                marginBottom: -40,
                transform: 'rotate(-45deg)',
              }}
            />
          </div>
        </>
      )
    } else {
      return (
        <>
          <div className={classes.rootSplash}></div>
        </>
      )
    }
  }

  const isTabPendent = useMemo(() => {
    return (
      objFeatureTab?.active &&
      conversation?.status === 'closed' &&
      (!conversation?.conversationTab || conversation?.pendingTab===true)
    )
  }, [objFeatureTab, conversation])

  const lastMessage = (channel) => {
    if (isTabPendent) {
      return t('commons.pendingTab')
    }

    const message = {
      telefone: t('commons.telefone'),
      real_automation: t('commons.ticket'),
    }    

    return message[channel] || lastMessageConversation.text;
  }

  const renderCustomer = () => {
    if (size === 'small') {
      return <></>
    } else {
      return (
        <>
          <div
            style={{
              width: '100%',
              marginLeft: 10,
              overflow: 'hidden',
              wrap: 'nowrap',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            <Typography
              variant="body1"
              style={{
                color:
                  theme.palette.type === 'dark'
                    ? activeConversation === props.data.conversationId &&
                      theme.palette.primary.secondary
                    : activeConversation === props.data.conversationId &&
                      '#fff',
              }}
            >
              {conversation.consumer.displayName
                ? conversation.consumer.displayName +
                  ` (${t('commons.edited')})`
                : conversation.consumer.name}
            </Typography>
            <Typography
              variant="body2"
              style={{
                color: theme.palette.hover4,
                overflow: 'hidden',
                wrap: 'nowrap',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
            >
              {lastMessage(conversation?.channel)}
            </Typography>
          </div>
        </>
      )
    }
  }

  const updateActiveConversation = () => {
    if (activeConversation === props.data.conversationId) {
      // dispatch(setUndockActiveConversation(null))
      // dispatch(setUndockConversation(null))
      // dispatch(setUndockConversations(null))
      // dispatch(setActiveConversation(null))
    } else {
      dispatch(setUndockActiveConversation(props.data.conversationId))
      dispatch(setUndockConversation(conversation))
      dispatch(setUndockConversations(conversations))
      dispatch(setActiveConversation(props.data.conversationId))
    }
  }

  const classItem = useMemo(() => {
    if (activeConversation === props?.data?.conversationId) {
      return classes.rootActive
    }
    if (isTabPendent) {
      return classes.rootPendent
    }
    return classes.root
  }, [activeConversation, conversation, classes, isTabPendent])

  return (
    <>
      {conversation && (
        <div
          onClick={(e) => {
            e.stopPropagation()
            updateActiveConversation()
          }}
          className={classItem}
        >
          {renderCustomer()}
          {renderSplash()}
          <div className={classes.rootDetails}>
            <div className={classes.rootIcon}>
              <Status
                chatId={props?.chatId}
                ticket={conversation?.channel === 'real_automation'}
                withSummary
              />
            </div>
            {unreadMsgs > 0 && (
              <div className={classes.rootBadge}>
                <Typography
                  variant="body2"
                  style={{
                    fontWeight: 'bold',
                  }}
                >
                  {unreadMsgs}
                </Typography>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  )
}

export default memo(Item)
